const drawerWidth = 265;

export default drawerWidth;